import B_Real from '../../../../base/dev/child/base/B_Real';
import B_ChildWorld from '../../../../base/dev/child/base/B_ChildWorld';
import B_GridChild from '../../../../base/dev/child/grid/B_GridChild';
import B_Inventory from '../../../../base/dev/child/attr/B_Inventory';
import R_GridChild from '../grid/R_GridChild';
import R_Define from '../../util/R_Define';
import MixinBuilder from '../../../../base/dev/scripts/MixinBuilder';
import B_Util from '../../../../base/dev/util/B_Util';

const mix = superclass => new MixinBuilder(superclass);

const init = () => {
    return class R_SpriteHero extends mix(B_Real).with(
        B_ChildWorld, B_GridChild, R_GridChild, B_Inventory
    ) {
        constructor(obj) {
            super(obj);

            this._animation = 'idle';
            this._isOnJump = false;
            this._isOnSlide = false;
            this._jumpEvt = null;
            this._tempX = 0;
            this._tempY = 0;
            this._jumpMoveCnt = 0;
            this._jumpSpped = null;
            this._jumpCb = null;
            this._tempAnimation = null;
            this.hitItemCount = 0;
            this._invincible = {
                on: false,
                blinkStartEvt: null,
                blinkEvt: null,
                resetEvt: null
            };
            this._isRun = false;

            this._w = this._gridDisX * this._size / 100;
            this._h = this._gridDisY * this._size / 100;

            this.rotate = obj.rotate || this.CODMOS._res[obj.res].rotate || 180;

            this._sprite = this.CODMOS._sprite[obj.res];
            this._object = new createjs.Sprite(this._sprite);
            this._container.addChild(this._object);

            this._speed = this.CODMOS.ANIMATE._tween.getCanvas().speed;

            // 시작 시 기본 이미지 / 달리기 프레임 중 첫 프레임
            // this._object.gotoAndStop(this._sprite.getAnimation('run').frames[0]);
            this._object.gotoAndPlay(this._animation);
        }

        setFilter() {
            const filter = new createjs.ColorMatrixFilter([
                Math.random(), Math.random(), Math.random(), 0, 0, // red component
                Math.random(), Math.random(), Math.random(), 0, 0, // green component
                Math.random(), Math.random(), Math.random(), 0, 0, // blue component
                0, 0, 0, 1, 0 // alpha
            ]);
            const [bmp] = this._sprite.bmps;
            bmp.filters = [filter];
            bmp.cache(0, 0, bmp.image.width, bmp.image.height);
        }

        /**
         * [ Function :: _endJump ]
         *
         * @DES :: 점프 애니메이션 강제 종료. 단 점프 동작 시작 시와 _endJump 이벤트 시 속도가 다르거나 force 옵션이 참일 경우에만 동작
         * @IP1 :: force {boolean}
         * @O.P :: null
         */
        _endJump(force) {
            if (
                force
                || this._jumpSpped !== this.CODMOS.speed
            ) {
                this._jumpMoveCnt = 0;
                this._isOnJump = false;

                clearInterval(this._jumpEvt);
                this._pixelY = this._tempY;
                this.animation = this._isRun ? 'run' : null;

                if (this._jumpCb) {
                    this._jumpCb();
                    this._jumpCb = null;
                }
            }
        }

        /**
         * [ Function :: _move ]
         *
         * @DES :: run 이벤트를 통해 월드가 한 그리드 이동할 때마다 호출 됨. 점프 동작 중이고, 2 그리드 이동 했을 경우 _endJump 이벤트 호출
         * @O.P :: null
         */
        _move() {
            if (this._isOnJump) {
                this._jumpMoveCnt++;
                if (!(this._jumpMoveCnt % 2)) {
                    this._endJump();
                }
            }
        }

        /**
         * [ Function :: run ]
         *
         * @DES :: 월드에 run 이벤트 전달
         * @IP1 :: cb {function}
         * @O.P :: null
         */
        run(cb) {
            this.standUp();

            this._isRun = true;
            this.animation = 'run';

            this.CODMOS.WORLD._run();
            if (typeof cb === 'function') cb();
        }

        /**
         * [ Function :: jump ]
         *
         * @DES :: 점프 애니메이션 실행
         * @IP1 :: cb {function}
         * @O.P :: null
         */
        jump(cb) {
            if (!this._isOnJump) {
                this._isOnJump = true;

                this.standUp();

                // this.setFilter();

                this.animation = 'jump';

                this._jumpCb = cb;
            } else {
                cb();
            }
        }

        /**
         * [ Function :: slide ]
         *
         * @DES :: 슬라이딩 애니메이션 적용
         * @IP1 :: cb {function}
         * @O.P :: null
         */
        slide(cb) {
            // 점프 이벤트가 동작 중일 경우 점프 강제 종료
            if (this._isOnJump) {
                this._endJump(true);
            }

            this.animation = 'slide';
            this._isOnSlide = true;

            // 최소한 3 프레임 동작 후 다음 블록으로 넘어가도록
            const { _gridDisX } = this;

            const moveCnt = Math.ceil(
                _gridDisX * 2 / (R_Define.GET_TICK_MOVE_INTERVAL(_gridDisX) * this.CODMOS.speed)
            ) * R_Define.TICK_TIME_INTERVAL;

            const frameCnt = this._sprite.getAnimation('slide').frames.length;

            setTimeout(() => {
                cb();
            }, moveCnt / frameCnt * 3);
        }

        /**
         * [ Function :: standUp ]
         *
         * @DES :: 일어나기(달리기 모션) 동작
         * @IP1 :: cb {function}
         * @O.P :: null
         */
        standUp(cb) {
            // 점프 이벤트가 동작 중일 경우 무시
            if (
                this._isOnJump
                || !this.animation
            ) {
                this.animation = null;
            } else {
                this.animation = 'run';
            }

            if (this._tempX) {
                this._pixelX = this._tempX;
                this._tempX = 0;
                this._pixelY = this._tempY;
                this._tempY = 0;
            }

            this._isOnSlide = false;

            if (typeof cb === 'function') cb();
        }

        /**
         * [ Function :: changeHero ]
         *
         * @DES :: 캐릭터 리소스 변경
         * @IP1 :: res {string}
         * @IP2 :: cb {function}
         * @O.P :: null
         */
        changeHero(res, cb) {
            // 랜덤의 경우 현재 리소스를 제외하고 추출
            if (res === 'random') res = `halmet${B_Util.getRandomInt(1, 5, Number(this._res.slice(-1)))}`;
            this._res = res;

            this._sprite = this.CODMOS._sprite[res];
            this._object.spriteSheet = this._sprite;

            // 스프라이트시트 속도 적용
            this._speed = this._speed;

            if (this.animation) this._object.gotoAndPlay(this._animation);

            if (typeof cb === 'function') cb();
        }

        /**
         * [ Function :: useInvincible ]
         *
         * @DES :: 무적 기능 사용
         * @IP1 :: cb {function}
         * @O.P :: null
         */
        useInvincible(cb) {
            if (this._invincible.on) {
                const { blinkStartEvt, blinkEvt, resetEvt } = this._invincible;
                clearTimeout(blinkStartEvt);
                clearInterval(blinkEvt);
                clearTimeout(resetEvt);
            }

            this._invincible.on = true;

            // 투명도 적용
            this._object.alpha = 0.5;

            // 3.5초 후 깜박임 동작 실행
            this._invincible.blinkStartEvt = setTimeout(() => {
                this._object.alpha = 0.6;
                this._invincible.blinkEvt = setInterval(() => {
                    this._object.alpha = this._object.alpha === 0.6 ? 0.9 : 0.6;
                }, 70);
            }, 3500);

            // 5초 후 무적 기능 종료
            this._invincible.resetEvt = setTimeout(() => {
                this._object.alpha = 1;

                clearInterval(this._invincible.blinkEvt);

                this._invincible.on = false;
            }, 5000);

            if (typeof cb === 'function') cb();
        }

        _setArea() {
            this._container.scale = .65;
            this._container.scaleX = .65;
            this._container.scaleY = .65;
            this.rotate = this.rotate;
        }

        _setPoint(px, py) {
            if (super._checkReg(px, py)) {
                this._container.regX = this._pointX > 50
                    ? (this._pointX - 50) * -1
                    : Math.abs(this._pointX - 50);
                this._pointY = 100;
                this._container.regY = this._pointY > 50
                    ? Math.abs(this._pointY - 50)
                    : this._pointY - 50;

                this._container.regY += 20;
            }
        }

        clear() {
            this.animation = 'clear'
        }

        // 현재 적용 된 애니메이션
        get animation() { return this._animation; }

        set animation(animation) {
            if (this.animation === 'clear') return;

            this._animation = animation;
            switch (animation) {
                case null: {
                    this._object.gotoAndStop(this._sprite.getAnimation('run').frames[0]);
                    break;
                }
                case 'slide': {
                    this._object.gotoAndPlay(animation);
                    if (!this._tempX) {
                        this._tempX = this._pixelX;
                        this._tempY = this._pixelY;
                        const { width } = this._object.getBounds();
                        this._pixelX -= (((width * this._container.scale) - this._gridDisX) / 2) - 5;
                        this._pixelY += 50;
                    }
                    break;
                }
                case 'jump': {
                    const { _gridDisX, _gridDisY } = this;

                    this._jumpSpped = this.CODMOS.speed;

                    // 월드의 이동이 이뤄질 횟수 * 1회 이동 시간
                    const moveCnt = Math.ceil(
                        _gridDisX * 2 / (R_Define.GET_TICK_MOVE_INTERVAL(_gridDisX) * (this._jumpSpped || 2))
                    ) * R_Define.TICK_TIME_INTERVAL;

                    // 점프 동작 프레임 목록 가져오기
                    const frames = this._sprite.getAnimation('jumpRight').frames.slice(0);
                    const frameCnt = frames.length;
                    
                    this._tempY = this._pixelY;

                    let frame = frames.shift();

                    this._jumpEvt = setInterval(() => {
                        const frameIdx = frameCnt - frames.length;

                        this._object.gotoAndStop(frame);

                        // 점프 애니메이션 가중치 적용
                        const weight = R_Define.JUMP_WEIGHT[frameIdx];

                        if (typeof weight !== 'undefined') {
                            this._pixelY = this._tempY - _gridDisY * weight;
                        } else {
                            this._pixelY = this._tempY;
                        }

                        frame = frames.shift();

                        // 더 이상 프레임이 존재하지 않을 경우 이벤트 제거
                        if (typeof frame === 'undefined') {
                            this._jumpMoveCnt = 0;
                            this._isOnJump = false;

                            clearInterval(this._jumpEvt);
                            this._pixelY = this._tempY;
                            this.animation = this._isRun ? 'run' : null;

                            if (this._jumpCb) {
                                this._jumpCb();
                                this._jumpCb = null;
                            }
                        }
                    }, moveCnt / frameCnt);
                    break;
                }
                case 'clear': {
                    this._pixelY -= 20;
                    this._object.gotoAndPlay(animation);
                    break;
                }
                default: {
                    this._object.gotoAndPlay(animation);
                }
            }
        }

        // 현재 방향
        get rotate() { return this._rotate; }

        set rotate(rotate) {
            rotate = rotate % 360 || 360;
            switch (rotate) {
                case 90: {
                    this._container.scaleX = Math.abs(this._container.scaleX);
                    break;
                }
                case 180:
                case 270:
                case 360: {
                    this._container.scaleX = Math.abs(this._container.scaleX) * -1;
                    break;
                }
                default:
            }
            this._rotate = rotate;
        }

        // 게임 속도
        get _speed() { return this.CODMOS.ANIMATE._tween.getCanvas().speed; }

        set _speed(speed) {
            if (speed) {
                if (this.animation) this._object.play();
                this.CODMOS.ANIMATE._tween.getCanvas()._speed = speed;
                this._sprite.animations
                    .forEach((e) => {
                        const animation = this._sprite.getAnimation(e);
                        if (animation.tempFrames) {
                            animation.frames = animation.tempFrames;
                            delete animation.tempFrames;
                        }
                        animation.speed = speed * (
                            1000 / 24 * animation.frames.length
                        ) / 888;
                    });
            } else {
                const cFrame = this._object.currentFrame;
                this._sprite.animations
                    .forEach((e) => {
                        const animation = this._sprite.getAnimation(e);
                        const { frames } = animation;
                        if (e === 'jumpRight') {
                            animation.speed = 2 * (
                                1000 / 24 * frames.length
                            ) / 888;
                        } else {
                            if (!animation.tempFrames) {
                                animation.tempFrames = frames;
                            }
                            if (frames.includes(cFrame)) {
                                animation.frames = [cFrame];
                            } else {
                                animation.frames = [frames[0]];
                            }
                        }
                    });
                this._object.stop();
            }
        }

        get _isOnInvincible() { return this._invincible.on; }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/graphic/R_SpriteHero.js